const _ = require('lodash')
export default {
    id: "AU",
    name: "Audit",
    description: "",
    entities: _.concat(
        [
            require("./audit/organizationAxis").entity,
            require("./audit/organization").entity,
            require("./audit/axisType").entity,
            require("./audit/axis").entity,
            require("./audit/riskType").entity,
            require("./audit/risk").entity,
            require("./audit/maturityControl").entity,
            require("./audit/controlType").entity,
            require("./audit/control").entity,
            require("./audit/stakeholderType").entity,
            require("./audit/stakeholder").entity,
            require("./audit/document").entity,
            require("./audit/test").entity,
            require("./audit/auditMenu/preparation").entity,
            require("./audit/dashboard").entity,
        ]
    ),
    modules: _.concat(
        [
            require("./audit/organizationAxis").module_,
            require("./audit/organization").module_,
            require("./audit/axisType").module_,
            require("./audit/axis").module_,
            require("./audit/riskType").module_,
            require("./audit/risk").module_,
            require("./audit/controlType").module_,
            require("./audit/maturityControl").module_,
            require("./audit/control").module_,
            require("./audit/stakeholderType").module_,
            require("./audit/stakeholder").module_,
            require("./audit/document").module_,
            require("./audit/test").module_,
            require("./audit/auditMenu/preparation").module_,
        ]
    )
};
